import { Box, Button, Typography, styled } from '@material-ui/core'
import { ContainerPage, TitlePage, Title } from 'components'
import { ClientCritical } from 'components/ClientCritical'
import { Edit, IEdit } from 'components/ModalEditOrder/Edit'
import {
  ContainerInfos,
  ModalPrinter,
  Separations,
  SkeletonLoading,
  SummaryOrder,
  Boxes,
} from 'components/pages/OrderDetails'
import { useOrderDetails } from 'hooks/useOrderDetails'
import { enStatus } from 'interfaces/IOrder'
import { useState, useRef, useMemo } from 'react'
import { AiOutlinePrinter } from 'react-icons/ai'
import { FaCheck } from 'react-icons/fa'
import { IoIosArrowForward } from 'react-icons/io'
import { MdModeEditOutline, MdNotInterested } from 'react-icons/md'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { getLastUpdateHourAndMinute } from 'utils'

import { ContainerTipInfo, useStyles } from './styles'

const InfoStyle = styled(Typography)({
  color: '#757575',
  fontWeight: 400,
  fontSize: '0.87rem',
  lineHeight: '1.31rem',
  marginBottom: '0.25rem',
  '& strong': {
    color: '#353535',
    fontWeight: 500,
    fontSize: '1rem',
  },
})

const OrderDetails = () => {
  const classes = useStyles()
  const [search] = useSearchParams()
  const [modalReprint, setModalReprint] = useState(false)
  const navigate = useNavigate()
  const {
    orderData,
    summaryData,
    separations,
    isLoading,
    refresh,
    orderConferenceData,
    endtimeOrder,
    boxesImage,
    loadingData,
  } = useOrderDetails()
  const editRef = useRef<IEdit>(null)
  const handleOpenReprint = () => setModalReprint(true)
  const handleCloseReprint = () => setModalReprint(false)
  const { startSeparation, separatorName } = useMemo(() => {
    const workSeparation = separations.find(separation => separation.items?.length)?.items[0]?.work
    return {
      startSeparation: workSeparation?.begin,
      separatorName: workSeparation?.separator?.username,
      endTimeSeparation: workSeparation?.end,
    }
  }, [separations])
  const view = search.get('view')
  return (
    <>
      <ContainerPage>
        <TitlePage className={classes.titlePage}>
          <button onClick={() => navigate(-1)} className={classes.link}>
            {view ? 'Pedidos' : 'Dashboard'}
          </button>
          <IoIosArrowForward fontSize="1.125rem" />
          {orderData?.order_id && `#${orderData?.order_id}`}
        </TitlePage>

        {isLoading ? (
          <SkeletonLoading />
        ) : (
          <>
            <Box component="header" className={classes.header}>
              <Box>
                <Typography variant="h1" className={classes.clientName}>
                  {orderData?.client_data?.client_type === 'PF'
                    ? orderData?.client_data?.client_name
                    : orderData?.client_data?.client_trade}
                  {orderData?.is_critical && <ClientCritical />}
                </Typography>
              </Box>

              <Box style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
                <Button
                  className={classes.btnEdit}
                  onClick={() => {
                    editRef.current?.handleData(orderData)
                  }}
                >
                  <MdModeEditOutline size={25} /> Editar Pedido
                </Button>
                <Button className={classes.btnReprint} onClick={handleOpenReprint}>
                  <AiOutlinePrinter size={25} color="#757575" />
                  Reimprimir etiqueta
                </Button>
              </Box>
            </Box>
            <ContainerTipInfo>
              {orderData?.replacement_order && (
                <Box
                  className={classes.box}
                  style={{ backgroundColor: '#EFEFEF', height: '45px', padding: '4px 16px' }}
                >
                  <div style={{ display: 'flex' }}>
                    <InfoStyle
                      style={{
                        fontFamily: 'Inter',
                        fontSize: '16px',
                        fontStyle: 'normal',
                        fontWeight: '600',
                        lineHeight: 'normal',
                        color: '#7B7B7B',
                      }}
                    >
                      Reposição do pedido {orderData?.replacement_order?.old_order}
                    </InfoStyle>
                  </div>
                </Box>
              )}

              {orderData.permission_to_separate === enStatus.recused && (
                <Box
                  className={classes.box}
                  style={{ backgroundColor: '#FFDBCD', width: '180px', height: '45px' }}
                >
                  <div style={{ display: 'flex' }}>
                    <InfoStyle
                      style={{
                        fontFamily: 'Inter',
                        fontSize: '16px',
                        fontStyle: 'normal',
                        fontWeight: '600',
                        lineHeight: 'normal',
                        color: '#BB1F32',
                      }}
                    >
                      Pedido cancelado
                    </InfoStyle>
                  </div>
                </Box>
              )}
            </ContainerTipInfo>

            <ContainerInfos {...orderData} />
            <Box className={classes.content}>
              <Box width="100%" className={classes.containerSeparations}>
                {orderData?.instructions && (
                  <Box className={classes.instructions}>
                    <Title style={{ color: '#353535' }}>Observação do pedido</Title>
                    <Typography>{orderData?.instructions}</Typography>
                  </Box>
                )}

                <Boxes boxesImage={boxesImage} loadingData={loadingData} />

                <Separations separations={separations} order={orderData} refresh={refresh} />

                <Box mt="0.5rem">
                  <InfoStyle>
                    Finalizado as: <strong>{getLastUpdateHourAndMinute(endtimeOrder)}</strong>
                  </InfoStyle>
                </Box>
              </Box>
              <SummaryOrder
                textTotal="Total de itens"
                textCompleted="Itens finalizados"
                textPedding="Itens em separação"
                textTimer="Tempo de separação"
                textSeparator="Separado por"
                textConferencer="Conferido por"
                textRevision="Revisado?"
                completed={summaryData.completed}
                totalItens={summaryData.totalItens}
                itensPending={summaryData.itensPending}
                separations={separations}
                startSeparation={startSeparation}
                separatorName={separatorName}
                conferencerName={orderConferenceData?.checked_by?.username}
                isReviwed={orderConferenceData.has_been_reviewed ? 'Sim' : 'Não'}
              />
            </Box>
          </>
        )}
      </ContainerPage>

      <ModalPrinter
        open={modalReprint}
        handleClose={handleCloseReprint}
        track={orderData?.separation_group}
        orderId={orderData?.order_id}
      />
      <Edit ref={editRef} refresh={refresh} />
    </>
  )
}

export default OrderDetails
